import { imageStorage } from 'api/Firebase'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { v4 as uuidv4 } from 'uuid'

interface UploadImageOptions {
  image: File
  folder: string
}

export function getFullSizeImage(url: string) {
  // The Image service defaults to a scaled-down size
  if (url.includes('lh3.googleusercontent')) {
    return `${url}=s0`
  }
  return url
}

export async function uploadImageAndGetData({
  image,
  folder,
}: UploadImageOptions) {
  const imageId = uuidv4()
  const extension = image.name.slice(image.name.lastIndexOf('.') + 1)
  const fileRef = ref(imageStorage, `${folder}/${imageId}.${extension}`)

  const uploadResult = await uploadBytes(fileRef, image)
  const downloadURL = await getDownloadURL(uploadResult.ref)

  return {
    bucketFileName: `${uploadResult.ref.bucket}/${uploadResult.ref.fullPath}`,
    url: downloadURL,
  }
}
